module.exports = __webpack_public_path__ + "img/symbol_11.c5b6fdbd.png";